/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-08-03",
    versionChannel: "nightly",
    buildDate: "2024-08-03T00:05:20.391Z",
    commitHash: "815bc3bcd77c3cbf279cf7bff1f1be63447c3664",
};
